import React from 'react';
// import { SkeletonCardProps } from './types';
// import { SkeletonBase } from './SkeletonBase';
// import './Skeleton.css';

type SkeletonAnimation = 'pulse' | 'wave' | 'none';

interface SkeletonCardProps {
  cardCount?: number;
//   hasAvatar?: boolean;
//   hasImage?: boolean;
//   lines?: number;
     animation?: SkeletonAnimation;
//   className?: string;
}

export const SkeletonCard: React.FC<SkeletonCardProps> = ({
  cardCount = 1,
//   hasAvatar = false,
//   hasImage = false,
//   lines = 3,
  animation = 'wave',
//   className = '',
}) => {
  const renderCard = () => (
    <div className="skeleton-card">
    <div className="skeleton skeleton-card-image"></div>
    <div className="skeleton skeleton-card-title"></div>
    <div className="skeleton skeleton-card-text"></div>
    <div className="skeleton skeleton-card-title"></div>
    <div className="skeleton skeleton-card-text"></div>
    <div className="skeleton skeleton-card-title"></div>
    <div className="skeleton skeleton-card-text"></div>
    <div className="skeleton skeleton-card-title"></div>
    <div className="skeleton skeleton-card-text"></div>
    <div className="skeleton skeleton-card-title"></div>
    <div className="skeleton skeleton-card-text"></div>
    <div className="skeleton skeleton-card-title"></div> 
    <div className="skeleton skeleton-card-text"></div>
    <div className="skeleton skeleton-card-title"></div> 
    <div className="skeleton skeleton-card-text"></div>
    </div>
  );

  return (
    <div className={"skeleton-grid"}>
      {Array.from({ length: cardCount }).map((_, index) => (
        <React.Fragment key={index}>
          {renderCard()}
        </React.Fragment>
      ))}
    </div>
  );
};

export default SkeletonCard;